let currentHoverTimeout = null;
let currentExpandedItem = null;

document.addEventListener('DOMContentLoaded', function() {
  
  // Grid-specific initialization
  const container = document.getElementById('stvs-store-wp-plugin-container');
  if (!container) {
    console.log('No grid container found, grid.js exiting');
    return;
  }

  // Initialize hover effects for grid
  initializeHoverEffects();

  let currentPage = parseInt(container.dataset.currentPage) || 1;
  let totalPages = parseInt(container.dataset.totalPages) || 1;
  const perPage = parseInt(container.dataset.perPage) || 25;

  // Overridden by the filter bar via the 'stvs:filter-change' custom event.
  // When null, loadPage falls back to the shortcode's own filter_by attribute.
  let activeFilterBy = null;
  
  // Handle pagination clicks
  container.addEventListener('click', function(e) {
    const button = e.target.closest('[data-pagination]');
    if (!button) return;
    
    e.preventDefault();
    
    const action = button.dataset.pagination;
    if (action === 'prev' && currentPage > 1) {
      currentPage--;
      loadPage(currentPage);
    } else if (action === 'next' && currentPage < totalPages) {
      currentPage++;
      loadPage(currentPage);
    } else if (action === 'page') {
      const targetPage = parseInt(button.dataset.page);
      if (targetPage && targetPage !== currentPage && targetPage >= 1 && targetPage <= totalPages) {
        currentPage = targetPage;
        loadPage(currentPage);
      }
    }
  });

  // Handle browser back/forward buttons
  window.addEventListener('popstate', function(event) {
    if (event.state && event.state.stvsPage) {
      currentPage = event.state.stvsPage;
      loadPage(currentPage, false);
    }
  });

  // Handle filter changes dispatched by filter-bar.js
  container.addEventListener('stvs:filter-change', function(event) {
    activeFilterBy = event.detail.filter_by;
    console.log('stvs:filter-change event received. Filter changed to:', activeFilterBy);
    currentPage = 1;
    loadPage(1);
  });
  
  async function loadPage(page, pushToHistory = true) {
    // Refresh nonce first to avoid cache-stale issues
    const nonceRes = await fetch('/wp-admin/admin-ajax.php?action=stvs_get_nonce');
    const nonceData = await nonceRes.json();
    const freshNonce = nonceData.success ? nonceData.data.nonce : container.dataset.nonce;

    // Show loading state
    const gridContainer = container.querySelector('.stvs-grid');
    const originalContent = gridContainer.innerHTML;
    let loadingHTML = '';
    for (let i = 0; i < perPage; i++) {
      loadingHTML += `<div class="stvs-animate-pulse stvs-relative hover:stvs-shadow-lg stvs-text-center   
        stvs-aspect-square stvs-w-full stvs-transition stvs-duration-300 stvs-z-10 hover:stvs-z-20 
        stvs-bg-gray-800"></div>`;
    }
    gridContainer.innerHTML = loadingHTML;
    
    // Gather all the shortcode attributes from data attributes
    const formData = new FormData();
    formData.append('action', 'stvs_load_page');
    formData.append('page', page);
    formData.append('per_page', container.dataset.perPage || 25);
    formData.append('categories', container.dataset.categories || 'all');
    formData.append('language', container.dataset.language || 'en');
    formData.append('skuable_type', container.dataset.skuableType || '');
    formData.append('exclude_skuable_type', container.dataset.excludeSkuableType || '');
    formData.append('ai_generated', container.dataset.aiGenerated || 'false');
    formData.append('sort_by', container.dataset.sortBy || '');
    formData.append('filter_by', activeFilterBy !== null ? activeFilterBy : (container.dataset.filterBy || ''));
    formData.append('video_thumbnails', container.dataset.videoThumbnails || 'false');
    formData.append('debug', container.dataset.debug || 'false');
    formData.append('nonce', freshNonce);
    
    // Make AJAX request to WordPress
    fetch('/wp-admin/admin-ajax.php', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        gridContainer.innerHTML = data.data.html;
        initializeHoverEffects(); // Re-initialize hover effects on new content

        const paginationContainer = container.querySelector('[class*="stvs-flex"][class*="stvs-justify-center"][class*="stvs-mt-8"]');
        if (data.data.pagination_html) {
          if (paginationContainer) {
            paginationContainer.outerHTML = data.data.pagination_html;
          } else {
            // Pagination didn't exist before (e.g. previous filter had 1 page) — append it
            container.querySelector('#stvs-store-grid').insertAdjacentHTML('afterend', data.data.pagination_html);
          }
        } else if (paginationContainer) {
          // New result has only 1 page — remove the old pagination entirely
          paginationContainer.remove();
        }
        
        if (data.data.debug_info) {
          console.group(`🔍 STVS Store Debug Info (Page ${page})`);
          console.log('API URL:', data.data.debug_info.api_url);
          console.log('Parameters:', data.data.debug_info.params);
          console.log('Response found:', data.data.total_found);
          console.log('Items returned:', data.data.html.split('stvs-clickable-container').length - 1);
          console.groupEnd();
        }

        if (pushToHistory) {
          const newUrl = new URL(window.location);
          newUrl.searchParams.set('page', page);
          window.history.pushState({ stvsPage: page }, '', newUrl);
        }
        container.dataset.totalPages = data.data.total_pages;
        totalPages = data.data.total_pages;
      } else {
        gridContainer.innerHTML = originalContent;
        console.error('Error loading page:', data.data);
      }
    })
    .catch(error => {
      gridContainer.innerHTML = originalContent;
      console.error('Network error:', error);
    });
  }
});

function initializeHoverEffects() {
  const gridContainer = document.getElementById('stvs-store-wp-plugin-container');
  
  if (gridContainer) {
    addHoverListeners(gridContainer);
  }
}

function addHoverListeners(container) {
  container.removeEventListener('mouseenter', handleItemHoverStart, true);
  container.removeEventListener('mouseleave', handleItemHoverEnd, true);
  
  container.addEventListener('mouseenter', handleItemHoverStart, true);
  container.addEventListener('mouseleave', handleItemHoverEnd, true);
}

function handleItemHoverStart(e) {
  const storeItem = e.target.closest('.stvs-store-item');
  if (!storeItem) return;

  if (currentHoverTimeout) {
    clearTimeout(currentHoverTimeout);
    currentHoverTimeout = null;
  }

  if (currentExpandedItem && currentExpandedItem !== storeItem) {
    closeExpandedItem(currentExpandedItem);
  }

  currentHoverTimeout = setTimeout(() => {
    if (storeItem.classList.contains('stvs-expanded')) return;
    expandItem(storeItem);
    currentExpandedItem = storeItem;
    currentHoverTimeout = null;
  }, 650);
}

function handleItemHoverEnd(e) {
  const storeItem = e.target.closest('.stvs-store-item');
  if (!storeItem) return;

  const relatedTarget = e.relatedTarget;
  if (relatedTarget && storeItem.contains(relatedTarget)) {
    return;
  }

  if (currentHoverTimeout) {
    clearTimeout(currentHoverTimeout);
    currentHoverTimeout = null;
  }

  if (currentExpandedItem === storeItem) {
    closeExpandedItem(storeItem);
    currentExpandedItem = null;
  }
}

function expandItem(storeItem) {
  if (window.innerWidth < 1024) {
    return;
  }
  // Grid-only logic - no slider checks needed
  const alignment = calculateAlignment(storeItem);
  const overlay = storeItem.querySelector('.stvs-hover-overlay');
  
  overlay.classList.remove('stvs-align-left', 'stvs-align-center', 'stvs-align-right');
  overlay.classList.add(`stvs-align-${alignment}`);

  const videoUrl = storeItem.dataset.videoUrl;
  storeItem.classList.add('stvs-expanded');
  morphBadges(storeItem, 'expand');
  if (videoUrl) {
    loadVideo(storeItem, videoUrl);
  }
}

function calculateAlignment(storeItem) {
  // Grid-only logic - viewport-based alignment
  const itemRect = storeItem.getBoundingClientRect();
  const viewportWidth = window.innerWidth;
  const containerRect = document.getElementById('stvs-store-grid').getBoundingClientRect();
  const overlayWidth = 800;

  const spaceOnLeft = itemRect.left - containerRect.left;
  const spaceOnRight = containerRect.right - itemRect.right;
  const itemCenter = itemRect.left + (itemRect.width / 2);
  
  const centeredLeft = itemCenter - (overlayWidth / 2);
  const centeredRight = itemCenter + (overlayWidth / 2);

  if (centeredLeft >= containerRect.left && centeredRight <= containerRect.right) {
    return 'center';
  }
  
  if (spaceOnRight > spaceOnLeft) {
    return 'left';
  }
  
  return 'right';
}

function closeExpandedItem(storeItem) {
  morphBadges(storeItem, 'collapse');
  storeItem.classList.remove('stvs-expanded', 'stvs-animation-complete');
  
  const videoContainer = storeItem.querySelector('.stvs-video-container');
  if (videoContainer) {
    const video = videoContainer.querySelector('video');
    if (video) {
      video.pause();
      video.remove();
    }
    videoContainer.classList.remove('stvs-video-loaded');
  }
}

function morphBadges(storeItem, direction) {
  const originalBadges = storeItem.querySelectorAll('.stvs-item-badge');
  const expandedBadgesContainer = storeItem.querySelector('.stvs-expanded-badges');
  
  if (!expandedBadgesContainer) return;
  
  if (direction === 'expand') {
    expandedBadgesContainer.innerHTML = '';
    
    originalBadges.forEach((badge, index) => {
      const clonedBadge = badge.cloneNode(true);
      
      clonedBadge.classList.add('stvs-badge-horizontal');
      clonedBadge.classList.remove('stvs-absolute', 'stvs-top-0', 'stvs-top-[30px]', 'stvs-top-[60px]', 'stvs-left-0', 'stvs-left-[50%]', 'stvs-flex-col');
      clonedBadge.classList.add('stvs-relative', 'stvs-rounded-md');
      
      for (const child of clonedBadge.children) {
        child.classList.remove('stvs-rounded-br-md', 'stvs-rounded-e-md', 'stvs-rounded-tr-md');
        child.classList.add('stvs-rounded-md');
      }
      
      clonedBadge.style.opacity = '0';
      clonedBadge.style.transform = 'translateY(20px)';
      
      expandedBadgesContainer.appendChild(clonedBadge);
      
      setTimeout(() => {
        clonedBadge.style.transition = 'all 0.3s ease';
        clonedBadge.style.opacity = '1';
        clonedBadge.style.transform = 'translateY(0)';
      }, index * 100);
    });
    
    originalBadges.forEach(badge => {
      badge.style.transition = 'opacity 0.3s ease';
      badge.style.opacity = '0';
    });
    
  } else if (direction === 'collapse') {
    originalBadges.forEach(badge => {
      badge.style.opacity = '1';
    });
    
    setTimeout(() => {
      expandedBadgesContainer.innerHTML = '';
    }, 300);
  }
}

function loadVideo(storeItem, videoUrl) {
  const videoContainer = storeItem.querySelector('.stvs-video-container');
  if (!videoContainer || !videoUrl) return;

  const video = document.createElement('video');
  video.src = videoUrl;
  video.muted = true;
  video.loop = true;
  video.playsInline = true;
  video.autoplay = true;
  
  video.addEventListener('loadeddata', () => {
    videoContainer.classList.add('stvs-video-loaded');
  });
  
  video.addEventListener('error', (e) => {
    console.log('Video failed to load:', e);
  });
  
  videoContainer.appendChild(video);
}